module.exports = ":host button {\n  position: relative;\n  top: -0.4rem; }\n"